export interface SiteNote {
    message: string;
    createdAt?: string;
    createdBy?: string;
    createdById?: string;
}

export const normalizeLookupId = (value: string): string =>
    value.trim().toLowerCase().replace(/^[{([]+/, "").replace(/[)}\]]+$/, "");

export function parseSiteNotes(data: unknown): SiteNote[] {
    if (!data || typeof data !== "object") return [];
    const record = data as Record<string, unknown>;
    const rawNotes: unknown[] = Array.isArray(data) ? data
        : Array.isArray(record.notes) ? record.notes
            : Array.isArray(record.siteNotes) ? record.siteNotes : [data];
    return rawNotes.flatMap((raw): SiteNote[] => {
        if (typeof raw === "string") return raw.trim() ? [{ message: raw.trim() }] : [];
        if (!raw || typeof raw !== "object") return [];
        const item = raw as Record<string, unknown>;
        const message = item.message ?? item.note ?? item.text;
        if (typeof message !== "string" || !message.trim()) return [];
        const date = [item.createdAt, item.createdOn, item.createdDateTime].find(value => typeof value === "string");
        const name = item.createdByName ?? item.CreatedByName ?? item.userName ?? item.username
            ?? item.createdByUserName ?? item.createdByDisplayName ?? item.createdByFullName;
        const id = item.createdById ?? item.CreatedById ?? item.createdByUserId ?? item.userId ?? item.userGuid ?? item.createdBy;
        let createdBy: string | undefined;
        let createdById: string | undefined;
        if (typeof name === "string" && name.trim()) createdBy = name.trim();
        else if (name && typeof name === "object") {
            const author = name as Record<string, unknown>;
            const display = author.name ?? author.displayName ?? author.fullName ?? author.userName;
            if (typeof display === "string" && display.trim()) createdBy = display.trim();
            const authorId = author.id ?? author.userId;
            if (!createdBy && typeof authorId === "string" && authorId.trim()) createdById = normalizeLookupId(authorId);
        }
        if (!createdBy && !createdById && typeof id === "string" && id.trim()) {
            const value = id.trim();
            if (/^[{(]?[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}[)}]?$/i.test(value)) {
                createdById = normalizeLookupId(value);
            } else createdBy = value;
        }
        return [{ message: message.trim(), createdAt: typeof date === "string" ? date : undefined, createdBy, createdById }];
    });
}

export function sortNotesNewestFirst(notes: SiteNote[]): SiteNote[] {
    const timestamp = (note: SiteNote) => {
        const value = Date.parse(note.createdAt ?? "");
        return Number.isNaN(value) ? Number.NEGATIVE_INFINITY : value;
    };
    return [...notes].sort((left, right) => {
        const first = timestamp(left);
        const second = timestamp(right);
        return first === second ? 0 : first > second ? -1 : 1;
    });
}

export function getNoteAuthorText(note: SiteNote, users: Record<string, string>): string {
    return note.createdBy?.trim() || (note.createdById && users[normalizeLookupId(note.createdById)]) || "Unknown user";
}
